import { Component, OnInit, Input } from '@angular/core';
import { ProgressBar } from '../../interfaces/progress-bar.interface';
import { TranslateService } from '../../services/translate.service';

@Component({
  selector: 'mono-common-progress-bar',
  templateUrl: './progress-bar.component.html'
})
export class ProgressBarComponent implements ProgressBar, OnInit {

  public readonly defaultLanguage = "en";

  @Input() showProgressBar = false;
  @Input() totalSteps: number;
  @Input() hideOnMobile? = false;
  @Input() showProgressPercentage = false;
  @Input() language = this.defaultLanguage;
  @Input() context?;

  @Input() set currentStep(currentStep: number) {
    this.checkForProgressInputs(currentStep, this.totalSteps);
  }

  public progressPercentage = 0;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {}

  public checkForProgressInputs(currentStep: number, totalSteps: number) {
    this.calculatePercentage(currentStep, totalSteps);
  }

  public translate(template: string) {
    return this.translateService.translate(template, this.language);
  }

  private calculatePercentage(currentStep, totalSteps) {
    this.progressPercentage = Math.ceil(currentStep / totalSteps * 100);
    if (this.progressPercentage !== this.progressPercentage) {
      this.progressPercentage = 0;
    }
  }
}
